/* unplugin-vue-components disabled */import { render } from "./standardmap.vue?vue&type=template&id=5dc11a7b&scoped=true"
import script from "./standardmap.vue?vue&type=script&lang=js"
export * from "./standardmap.vue?vue&type=script&lang=js"

import "./standardmap.vue?vue&type=style&index=0&id=5dc11a7b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc11a7b"]])

export default __exports__